import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";
import Select from "react-select";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess, toastWarn } from "../../../common/Toast";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  DATA_EXPORT,
  ERROR_MESSAGE,
} from "../../../common/Constant";
import { Calendar } from "../../../common/imagePath";
import ReactDatetime from "react-datetime";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const SalesDeliveryReport = (props) => {
  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [selectedStatus, setSelectedStatus] = useState(0);
  const [deliveryemployeeDropdown, setDeliveryemployeeDropdown] = useState([]);
  const [statusDropdown, setStatusDropdown] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(0);
  const [rowSaleId, setRowSaleId] = useState(0);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [showList, setShowList] = useState([]);
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [selectedlocationid, setSelectedLocationID] = useState(
    Number(location)
  );
  const [totalData, setTotalData] = useState({
    TotalSum: 0,
    SubTotalSum: 0,
    TaxSum: 0,
    CostOfGoodsSoldSum: 0,
    ProfitSum: 0,
  });
  console.log(showList, showList[0]?.SaleId, rowSaleId, "totalData======>");

  let dashStyle = {
    // width: "280px",
    background: "#fff",
    marginTop: "10px",
    borderRadius: "6px",
    padding: "20px",
    border: "1px solid #E8EBED",
  };

  const handleDropdownChange = (event) => {
    console.log(event, "event123");
    setSelectReport(event?.value);
    if (event?.value === 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const handleLocationDropdownChange = (event) => {
    setSelectedLocationID(event?.value);
    console.log(event?.value, "Location chnage");
  };

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${config.employeesBaseUrl}/employees/usersdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setDeliveryemployeeDropdown(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.salesconfigBaseUrl}/sales/deliverystatuslist`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setStatusDropdown(res.data.ResponseData);
        return res;
      });
  }, []);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  let statusOptions = [];
  const statusDropDownData = statusDropdown.map((u, i) => {
    statusOptions[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  const locationDropdownOption = [
    { label: "All", value: 0 }, // Adding "All" option
    ...locationdropdown.map((u) => ({ label: u.Name, value: u.Id })),
  ];

  const HandleDropdownChange = (selectedEmployee) => {
    console.log(selectedEmployee, "selectedEmployee");
    setSelectedEmployee(selectedEmployee?.value); // Set the selected option to state
  };

  console.log(selectedStatus, "event");
  const handleStatusChnage = (event) => {
    setSelectedStatus(event?.value);
  };

  useEffect(() => {
    setEmployeeOptions(
      deliveryemployeeDropdown.map((u) => ({
        label: u.Name,
        value: u.eID,
      }))
    );
  }, [deliveryemployeeDropdown]);

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const handleRowsSaleId = (saleId) => {
    console.log(saleId, "saleIdcheck");
    setRowSaleId(saleId);
    setShowList([]);
    if (saleId > 0) {
      axios
        .get(
          `${config.reportsBaseUrl}/reports/showsaleitemsbyid?saleid=${saleId}&issaleitem=0&itemids=`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log("ShowList======>", res);
          setShowList(res.data.ResponseData);
          return res;
        });
    }
  };

  const columns = useMemo(() => [
    {
      header: "Sale Id",
      accessorKey: "SaleId",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Location",
      accessorKey: "Location",
      filterFn: "contains",
      size: "100",
    },
    {
      header: "Date",
      accessorKey: "Date",
      filterFn: "contains",
      size: "100",
      Cell: ({ row }) =>
        moment(row.original.Date).format("YYYY-MM-DD") === "Invalid date"
          ? ""
          : moment(row.original.Date).format(`${dateFormate.toUpperCase()} h:mm A`),
    },
    {
      header: "Status",
      accessorKey: "Name",
      filterFn: "contains",
      size: "130",
    },
    {
      header: "Delivery Employee",
      accessorKey: "deliveryemployee",
      filterFn: "contains",
    },
    {
      header: "Item Purchased",
      accessorKey: "itempurchase",
      filterFn: "contains",
      Cell: ({ row }) => (
        <Link
          style={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "600",
            p: "0.3rem",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          type="button"
          onClick={() => handleRowsSaleId(row?.original?.PosId)}
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
        >
          Show Items
        </Link>
      ),
    },
    {
      header: "Sold By",
      filterFn: "contains",
      accessorKey: "SoldBy",
    },
    {
      header: "Sold To",
      accessorKey: "soldto",
      filterFn: "contains",
    },
    // {
    //     header : "Register",
    //     accessorKey : "Register",
    // },
    {
      header: "Sub Total",
      accessorKey: "SubTotal",
      filterFn: "contains",
      size: "120",
      Cell: ({ row }) => {
        const Subtotal = row?.original?.SubTotal;
        if (Subtotal == "0.00" || Subtotal == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(Subtotal),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Total",
      accessorKey: "Total",
      filterFn: "contains",
      size: "120",
      Cell: ({ row }) => {
        const total = row?.original?.Total;
        if (total == "0.00" || total == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(total),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Tax",
      accessorKey: "Tax",
      size: "110",
      filterFn: "contains",
      Cell: ({ row }) => {
        return (
          <div>
            {CurrencySymbols(
              Number(row?.original?.Tax),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
    },
    {
      header: "Profit",
      accessorKey: "Profit",
      filterFn: "contains",
      size: "120",
      Cell: ({ row }) => {
        return (
          <div>
            {CurrencySymbols(
              Number(row?.original?.Profit),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
        // }
      },
    },
    {
      header: "Cost Of Good Sold",
      accessorKey: "CostOfGoodSold",
      filterFn: "contains",
      size: "120",
    },
    // {
    //   header: "payment Type",
    //   accessorKey: "paymentType",
    //   filterFn: "contains",
    //   size: "120",
    // },
    {
      header: "Comment",
      filterFn: "contains",
      accessorKey: "Comment",
    },
    // {
    //     header : "User Name",
    //     accessorKey : "UserName"
    // },
  ]);

  const apiCall = () => {
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/salesdeliveriesreport?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&filtertext=&startdate=${startdate}&enddate=${enddate}&selectedEmployee=${selectedEmployee}&locationid=${selectedlocationid}&status=${selectedStatus}&currentlocationid=${location}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          if (res.data.ResponseData.length > 0) {
            setResponseData(res.data.ResponseData);
            setTotalData({
              ...totalData,
              TotalSum: res.data.ResponseData[0].TotalSum,
              SubTotalSum: res.data.ResponseData[0].SubTotalSum,
              TaxSum: res.data.ResponseData[0].TaxSum,
              CostOfGoodsSoldSum: res.data.ResponseData[0].CostOfGoodsSoldSum,
              ProfitSum: res.data.ResponseData[0].ProfitSum,
            });
            setLoading(false);
          } else {
            toastWarn("No Records Found!");
            setLoading(false);
          }
        }
        if (res.data.ResponseCode === "ERROR") {
          setLoading(false);
          toastError(ERROR_MESSAGE);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        return;
      });
    // setLoading(false);
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Sales Delivery Report
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report Period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>

            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Delivery Employee
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={employeeOptions}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    // value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      HandleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Locations
              </label>
              <div className="col-md-12 z-3">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  options={locationDropdownOption}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  // isClearable={true}
                  name="location"
                  id="location"
                  value={locationDropdownOption.find(
                    (e) => e.value === selectedlocationid
                  )}
                  onChange={(event) => {
                    handleLocationDropdownChange(event);
                  }}
                  className="custom-search-select"
                ></Select>
              </div>
            </div>
            <div className="col-sm-2">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Status
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={statusOptions}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    // value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleStatusChnage(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apiCall()}
              >
                Run Report
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <>
              <div
                className="row mt-3"
                style={{
                  display: "grid",
                  gap: "1rem",
                  // gridTemplateColumns: "repeat(5,1fr)"
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                }}
              >
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.SubTotalSum} */}
                        {CurrencySymbols(
                          Number(totalData.SubTotalSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Subtotal</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.TotalSum} */}
                        {CurrencySymbols(
                          Number(totalData.TotalSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Total</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.TaxSum} */}
                        {CurrencySymbols(
                          Number(totalData.TaxSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Tax</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.ProfitSum} */}
                        {CurrencySymbols(
                          Number(totalData.ProfitSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Profit</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">{CurrencySymbols(
                          Number(totalData.CostOfGoodsSoldSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}</p>
                      {/* <p className="p-20">${totalData.CostOfGoodsSoldSum}</p> */}
                      <div className="d-flex">
                        <p className="p-medium">Cost Of Goods Sold Sum</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card mt-3" id="print">
                <div className="card-body">
                  <div className="container">
                    <div className="col-md-12 text-center" id="header">
                      <h6 className="P">Sonar Pos</h6>
                      <p className="fw-bold p-regular">Sales Delivery Report</p>
                      <div className="row">
                        <p>
                          Date:{" "}
                          {startdate === "" && enddate === ""
                            ? "All Data"
                            : moment(startdate).format(
                                `${dateFormate.toUpperCase()}`
                              ) +
                              " - " +
                              moment(enddate).format(
                                `${dateFormate.toUpperCase()}`
                              )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div>
                    <CommonMatrialReactTable
                      MainHeading="Sonar POS"
                      ReportHeading="Sale Delivary List"
                      columns={columns}
                      data={responseData}
                      startdate={startdate}
                      enddate={enddate}
                      columnGrouping={[]}
                      columnsVisibility={{}}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {/* {rowSaleId == showList[0]?.SaleId && ( */}
      <div
        class="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="staticBackdropLabel">
                Purchased Items
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              {showList.map((row, index) => (
                <div key={index}>{row.ItemName}</div>
              ))}
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => setShowList([])}
              >
                Close
              </button>
              {/* <button type="button" class="btn btn-primary">
                Understood
              </button> */}
            </div>
          </div>
        </div>
      </div>
      {/* )} */}
    </>
  );
};

export default SalesDeliveryReport;
